export default [{
    value: '',
    label: '全部'
}, {
    value: '1',
    label: '交易补贴'
}, {
    value: '2',
    label: '团队交易补贴'
}, {
    value: '3',
    label: '卓越领导奖励补贴'
}
];



// WEBPACK FOOTER //
// ./src/service/constant/PlatoonLicenTypes.js